import { createSelector } from '@ngrx/store';

import { SharedApplicationState, UserPreferencesState } from '../shared-state.interface';

export const selectUserPreferences = (state: SharedApplicationState) => state.userPreferences;

export const userPreferencesSelector = createSelector(
    selectUserPreferences,
    (selectedUserPreferences: UserPreferencesState) => {
        return selectedUserPreferences.userPreferences;
    }
);
